













import store from "@/store";
import { Component, Vue } from "vue-property-decorator";
import { Mutation, Getter, State } from "vuex-class";
import { AppState } from "@/store/app/types";
import Navbar from "./components/Navbar.vue";
import Sidebar from "./components/Sidebar.vue";
import LoadingModal from "./components/modals/LoadingModal.vue";

import moment from "moment-timezone";

@Component({
  components: {
    Navbar,
    Sidebar,
    LoadingModal,
  },
})
export default class App extends Vue {
  @State("app") public appState: AppState;
  @Getter('app/showtopbar') public showtopbar: boolean;
  @Getter('app/showsidebar') public _showsidebar: boolean;
  @Mutation("app/setShowsidebar")
  public setShowsidebar: (value: boolean) => void;

  get showsidebar(): boolean {
    return this._showsidebar;
  }
  set showsidebar(value: boolean) {
    this.setShowsidebar(value);
  }

  public async created(): Promise<void> {
    // Set default timezone here, so we don't to pass it on every call
    moment.tz.setDefault(this.appState.timezone);

    // Always try to show a prompt when closing browser window/tab
    // (this will only work if some interaction has been done on the page)
    window.addEventListener("beforeunload", (event) => {
      // Check if there are any unsaved changes before showing the prompt on close or refresh
      // Cancel the event as stated by the standard.
      if (
        store.getters["maintenancejobs/hasUnsavedChanges"]
      ) {
        event.preventDefault();

        // Chrome requires returnValue to be set.
        event.returnValue = "";
      }
    });
  }
}
